import { IncomeFormFields } from '~/types/income';
import { formatDateShort } from '~/utils/formatDate';

export const initialValues: IncomeFormFields = {
  customer: undefined!,
  issue_date: formatDateShort(new Date().toISOString(), 'yyyy-MM-dd'),
  notes: undefined!,
  amount: undefined!,
};
